/* Flaschenbauer Mobile-Sortierung
   Treibt das versteckte <select is="facet-short"> und nutzt damit Hypers
   bestehende AJAX-Sortierung. Anwenden bewusst nur bei Klick/Tap oder Enter,
   NICHT bei jedem Radio-'change' (sonst sortiert das Durchpfeilen per Tastatur
   bei jedem Schritt und schliesst das Dropdown). */
class FbSort extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('.fb-sort__details');
    this.summary = this.querySelector('.fb-sort__summary');
    this.native = this.querySelector('[data-fb-sort-native]');

    this._onClick = this.onClick.bind(this);
    this._onKey = this.onKey.bind(this);
    this._onToggle = this.onToggle.bind(this);
    this._onDocClick = this.onDocClick.bind(this);

    this.addEventListener('click', this._onClick);
    this.addEventListener('keydown', this._onKey);
    if (this.details) this.details.addEventListener('toggle', this._onToggle);
    document.addEventListener('click', this._onDocClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
  }

  // Auswahl uebernehmen: verstecktes facet-short setzen + change feuern (AJAX-Sort)
  apply(value) {
    if (this.native && this.native.value !== value) {
      this.native.value = value;
      this.native.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.details) this.details.open = false;
  }

  optionFrom(target) {
    const opt = target.closest && target.closest('.fb-sort__option');
    return opt ? opt.querySelector('input[name="fb_sort"]') : null;
  }

  onClick(event) {
    const radio = this.optionFrom(event.target);
    if (radio) {
      radio.checked = true;
      this.apply(radio.value);
    }
  }

  onKey(event) {
    if (event.key === 'Escape') {
      if (this.details && this.details.open) {
        this.details.open = false;
        if (this.summary) this.summary.focus();
      }
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      const radio = this.optionFrom(event.target)
        || (event.target.matches && event.target.matches('input[name="fb_sort"]') ? event.target : null);
      if (radio) {
        event.preventDefault();
        radio.checked = true;
        this.apply(radio.value);
      }
    }
  }

  onToggle() {
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    }
  }

  onDocClick(event) {
    if (this.details && this.details.open && !this.contains(event.target)) {
      this.details.open = false;
    }
  }
}

if (!customElements.get('fb-sort')) {
  customElements.define('fb-sort', FbSort);
}
